import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";
import reducer from "../reducer";

const RecommendDetails = () => {
  const [state, dispatch] = React.useReducer(reducer, {
    title: "",
    date1: "",
    date2: "",
    address_level1: "",
    address_level2: "",
    category: "",
    publisher: "",
    qty: 0,
    baomignfangshi: "",
    content: "",
  });
  const auth = useSelector((state) => state.auth);
  const { id } = useParams();
  const uuid = new URLSearchParams(useLocation().search).get("u_id");
  const [favorite_id, setFavoriteId] = React.useState(0);
  const handleFavorite = () => {
    if (auth.id) {
      if (favorite_id > 0) {
        fetch(`/api/miscellaneous/favorite/${favorite_id}`, {
          method: "DELETE",
        }).then((response) => {
          if (response.status === 200) setFavoriteId(0);
        });
      } else {
        fetch("/api/miscellaneous/favorite", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            ref_id: auth.id,
            ref_id2: id,
            category: "推荐信息",
            tag: "个人用户",
            ref_uuid: auth.uuid,
            ref_uuid2: uuid,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.insertId > 0) setFavoriteId(data.insertId);
          });
      }
    } else {
      location.href = `#登录?id=${id}`;
    }
  };

  React.useEffect(() => {
    fetch(`/api/bulletin/${id}?option=notification&uuid=${uuid}`)
      .then((response) => response.json())
      .then((data) => {
        dispatch({ type: "set", payload: { key: "title", value: data.title } });
        dispatch({ type: "set", payload: { key: "date1", value: data.date1 } });
        dispatch({ type: "set", payload: { key: "date2", value: data.date2 } });
        dispatch({
          type: "set",
          payload: { key: "address_level1", value: data.address_level1 },
        });
        dispatch({
          type: "set",
          payload: { key: "address_level2", value: data.address_level2 },
        });
        dispatch({
          type: "set",
          payload: { key: "category", value: data.category },
        });
        dispatch({
          type: "set",
          payload: { key: "publisher", value: data.publisher },
        });
        dispatch({ type: "set", payload: { key: "qty", value: data.qty } });
        dispatch({
          type: "set",
          payload: { key: "baomignfangshi", value: data.baomignfangshi },
        });
        dispatch({
          type: "set",
          payload: { key: "content", value: data.content },
        });
        saveJournal({
          ref_id: auth.id,
          ref_uuid: auth.uuid,
          ref_id2: id,
          ref_uuid2: data.uuid,
          category: "浏览推荐信息",
          tag: "个人用户",
        });
      });
  }, []);

  React.useEffect(() => {
    if (0 < auth.id) {
      const url = [
        "/api/miscellaneous/favorite",
        "?option=by-ref_id-ref_id2-category-tag",
        `&ref_id=${auth.id}`,
        `&ref_id2=${id}`,
        "&category=推荐信息",
        "&tag=个人用户",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) setFavoriteId(data[0].id);
        });
    }
  }, [auth.id]);

  return (
    <>
      <div className="container-fluid">
        <div className="card border-0 shadow mt-2 interface-bottom">
          <ToBack category={state.title} />
          <div className="card-body">
            <div className="row">
              <div className="col strong-center">
                <strong>{state.title}</strong>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
              </div>
            </div>
            <div className="row">
              <div className="col">
                发布时间：
                {state.date1}
              </div>
            </div>
            <div className="row">
              <div className="col">
                截止日期：
                {state.date2}
              </div>
            </div>
            <div className="row">
              <div className="col">
                所属省份：
                {state.address_level1}
              </div>
            </div>
            <div className="row">
              <div className="col">
                工作地点：
                {state.address_level2}
              </div>
            </div>
            <div className="row">
              <div className="col">
                单位：
                {state.publisher}
              </div>
            </div>
            <div className="row">
              <div className="col">
                招聘人数：
                {state.qty}
              </div>
            </div>
            <div className="row">
              <div className="col">
                报名方式：
                {state.baomignfangshi}
              </div>
            </div>
            <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
            <div className="row mt-3">
              <div
                className="col editor-body"
                dangerouslySetInnerHTML={{ __html: state.content }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="recommond-bottom" />
      <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
        <div className="row text-center nav-row">
          <div className="col-2 nav-col" />
          <div className="col nav-col" />
          <div className="col-2 nav-col" />
          <div className="col-5 nav-col">
            <button type="button" className="btn btn-primary nav-btn" onClick={handleFavorite}>
              {favorite_id > 0 ? (
                <FontAwesomeIcon icon={faStar} style={{ color: "#FFFF00" }} fixedWidth />
              ) : (
                <FontAwesomeIcon icon={faStar} fixedWidth />
              )}
              收藏
            </button>
          </div>
        </div>
      </ul>
    </>
  );
};

export default RecommendDetails;
